import { render, staticRenderFns } from "./provinces-data.vue?vue&type=template&id=d1fdf6e0"
import script from "./provinces-data.vue?vue&type=script&lang=js"
export * from "./provinces-data.vue?vue&type=script&lang=js"
import style0 from "./provinces-data.vue?vue&type=style&index=0&id=d1fdf6e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports